import React from 'react';
import { GetCart, GetTotal } from './CartHandler';
import { formatter } from '../../utils/common.js'
import { useState,useEffect } from 'react';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_BASEURL;

function TotalsBlock (props) {
    const [cartTotal, setCartTotal] = useState(GetTotal());

    const [taxes, setTaxes] = useState(0);
    const headers = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + props.token.token
    };


    //BELOW Was a post method in the original project. I changed the post top get both this call and on the API.
    const getShippingTotal=()=>{
        try {
            axios.put(apiUrl + `/api/ShippingRate/GetUpsGroundRate`,JSON.stringify(GetCart()),{
                headers: headers

          })
              .then((response) => {
                // console.log("UPS GROUND RATE TOTALS BLOCK: ", response.data);
                  props.setShipping(response.data);
           
               })
              .catch((error) => {
                console.log(error);
              });
          } catch (error) {
            console.log(error);
          }
    }

    //below was a PUT in the original code. I changed this method to get in both the code and the API
    const getCartTax=()=>{
        try {
            axios.put(apiUrl + `/api/Items/GetCartTax`,JSON.stringify(GetCart()) ,{
                headers: headers
                // body: JSON.stringify(GetCart())
          })
              .then((response) => {
                // console.log("TotalsBlock GetCartTaxes Data: ", response.data);
               
                  setTaxes(response.data);
           
               })
              .catch((error) => {
                console.log(error);
              });
          } catch (error) {
            console.log(error);
          }
    }
    
    const setOrderTotal = () =>{
        props.setOrderTotal(cartTotal+props.shipping+taxes);
    }

    useEffect(() => {
        // console.log("Token on Totals Block",props.token);
        getShippingTotal();
        getCartTax();
        setOrderTotal();
    }, []);

    return (
        <aside className="bg-white shadow-lg rounded-2xl h-auto p-6 w-full max-w-md border-2 ">
        <h1 className="text-2xl font-semibold mb-4 text-gray-800">Total</h1>
        
        <div className="flex justify-between py-2">
          <span className="text-gray-600">Subtotal</span>
          <span className="font-medium">{formatter.format(cartTotal)}</span>
        </div>
        
        <div className="flex justify-between py-2">
          <span className="text-gray-600">Discount</span>
          <span className="font-medium">$0</span>
        </div>
        
        <div className="flex justify-between py-2">
          <span className="text-gray-600">Shipping</span>
          <span className="font-medium">{formatter.format(props.shipping)}</span>
        </div>
        
        <div className="flex justify-between py-2">
          <span className="text-gray-600">Taxes</span>
          <span className="font-medium">{formatter.format(taxes)}</span>
        </div>
        
        <hr className="my-4 border-gray-300" />
        
        <div className="flex justify-between font-semibold text-lg">
          <span>Total</span>
          <span>{formatter.format(cartTotal + props.shipping + taxes)}</span>
        </div>
      </aside>
    );



}
export default TotalsBlock;